<template>
    <div>
     
      <div v-if="currentPage == -1" class="survey-thankyou">
         <p>
            Thank you for using Smart LOA! <br/>
            Your feedback is valuable to us.<br/>
            May we ask you to rate us on the following services.
         </p>
         <button class="btn btn-primary mr-3 btn-md survey-btn" @click="nextPage">OK</button>
         <button class="btn btn-secondary btn-md survey-btn skip-btn" @click="closeSurvey">Skip Survey</button>
      </div>
      <form v-if="currentPage > -1" @submit.prevent="submitForm">
        <h2 class="survey-title">{{ surveyData.title }}</h2>
        <div class="survey-questions">
        <p></p>
        <div v-if="currentPage <= this.totalPages-1"  class="survey-options survey-rate">
            <div v-for="(option, optionIndex) in surveyOptions" :key="optionIndex">
                <div>{{option}}</div>
            </div>
        </div>
        </div>
        <div v-for="(question, index) in currentPageQuestions" :key="index">
          <div class="survey-questions">
            <p>{{ question.SurveyQuestion }}</p>
            <div class="survey-options">
                <div v-for="(option, optionIndex) in surveyOptions" :key="optionIndex">
                    <label :for="'q'+index+'o'+optionIndex" class="custom-radio">
                    <input type="radio" :id="'q'+index+'o'+optionIndex" :value="optionIndex" v-model="answers[question.SurveyCode]" class="custom-radio-input">
                    <span class="custom-radio-label"></span>
                    </label>
                </div>
            </div>
          </div>
        </div>
        
        <div class="survey-action-buttons">
        <button type="submit" class="btn btn-primary btn-md survey-btn" v-if="currentPage != -1 && currentPage != 2" >Next</button>
        <button type="button" class="btn btn-primary btn-md survey-btn"  v-if="currentPage > -1 && currentPage <= this.totalPages-1" @click="prevPage">Previous</button>
        </div>
      </form>
      <div v-if="currentPage > this.totalPages-1" class="survey-thankyou">
         <p class="suveyform-submit">
            Thank you for your time and feeback!<br/>
            Stay safe.
         </p>
         <button class="btn btn-primary btn-md survey-btn" @click="closeSurvey">OK</button>
      </div>

      <b-modal ref="error-modal" title="Error" @hidden="clearErrorMessage" class="custom-modal">
        <p>{{ errorMessage }}</p>
      </b-modal>
    </div>

    
  </template>
  
  <script>
  import axios from 'axios';

  export default {
    name: "SurveyForm",
     
    data() {
      return {
        answers: {},
        currentPage: -1,
        surveyOptions: [],
        surveySelectedOptions: 0,
        surveyData: {
        title: "Customer Survey",
        questionsPerPage: 2,
        questions: {},
        },
        showErrorModal: false,
        errorMessage: ''
      };
    },
    computed: {
      totalPages() {
        return Math.ceil(this.surveyData.questions.length / this.surveyData.questionsPerPage);
      },
      currentPageQuestions() {
        const startIndex = this.currentPage * this.surveyData.questionsPerPage;
        return this.surveyData.questions.slice(startIndex, startIndex + this.surveyData.questionsPerPage);
      }
    },
    methods: {
      showError() {
        this.errorMessage = 'You have an unanswered questions. Please click ok to go back.';
        this.$refs['error-modal'].show()
      },
      clearErrorMessage() {
        this.errorMessage = '';
      },

        closeSurvey() {
            this.$emit("closesurveyform", false);
        },

        nextPage() {
            var haserror = false;
        
            if(this.currentPage > -1) {
                if (this.currentPage < this.totalPages -1 ) {
                    if (Object.keys(this.answers).length < 2 ) {
                      
                        this.showError()
                        haserror = true;
                    }
                } 
            }
            
            if (!haserror) {
                this.currentPage++;
            }
           
            console.log('CURRENT', this.currentPage);
        },
        prevPage() {
            this.currentPage--;
        },
        submitForm() {
            var haserror = false;
            var submitf = false;

            console.log('COUNT', Object.keys(this.answers).length )
            console.log('TOTAL', this.totalPages)
            console.log('CURRENT',this.currentPage );
            
            if (this.currentPage == 0) {
                if (Object.keys(this.answers).length < 2 ) {
                  
                  this.showError()
                    haserror = true;   
                } else {
                  submitf = false;   
                }
            }

            if (this.currentPage == 1) {
                if (Object.keys(this.answers).length < 3 ) {
                    this.showError()
                    haserror = true;   
                } else {
                  submitf = true;   
                }
            }
            if (!haserror) {
                this.currentPage++;
                if (submitf) {
                  this.$emit("submit", this.answers);
                }
            }
        }
    },
    async created() {
           const response = await axios.post('/api/?action=get-survey-questions', {
                 Platform: 'Kiosk',
           })
           
           if (response) {
                this.surveyData.questions = response.data;
           }

           this.surveyOptions = ["Highly satisfied", "Satisfied", "Neutral", "Somewhat Dissatisfied", "Dissatisfied", "Not Applicable"]
           console.log(this.surveyOptions)
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  </style>